import { useMediaQuery } from "@mui/material";
const mobileResolution = "600px";
export const useLayoutConstants = (pathname) => {
    const mobileHome = "/Dashboard";
    const desktopHome = "/Dashboard";
    const isMobile = useMediaQuery(`(max-width: ${mobileResolution})`);
    const HomePage = isMobile ? mobileHome : desktopHome;
    const isHomePage = (isMobile && pathname === mobileHome) ||
        (!isMobile && pathname === desktopHome);
    const headerHeight = isHomePage && isMobile ? "220px" : "64px";
    return { headerHeight, isMobile, isHomePage, HomePage };
};
